<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card outlined height="80vh">
              <v-card-title> CRM Integration </v-card-title>
              <!-- <v-card-text>
                        <v-skeleton-loader
                            v-bind="skeltonLoaderAttrs"
                            type="list-item-avatar-two-line"
                        ></v-skeleton-loader>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <v-skeleton-loader
                                    v-bind="skeltonLoaderAttrs"
                                    type="article"
                                ></v-skeleton-loader>
                            </v-col>
                            <v-col  cols="12" sm="4">
                                <v-skeleton-loader
                                    v-bind="skeltonLoaderAttrs"
                                    type="article"
                                ></v-skeleton-loader>
                            </v-col>
                            <v-col  cols="12" sm="4">
                                <v-skeleton-loader
                                    v-bind="skeltonLoaderAttrs"
                                    type="article"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-skeleton-loader
                        class="mt-2"
                            v-bind="skeltonLoaderAttrs"
                            type="card, actions"
                        ></v-skeleton-loader>
                    </v-card-text>
                    <v-fade-transition>
                    <v-overlay
                        absolute
                        opacity="0.75"
                    >
                        <v-btn color="primary" rounded @click="sendRequestDialog = true" ><v-icon class="mr-2">mdi-lock-open</v-icon> Request Access</v-btn>
                    </v-overlay>
                    </v-fade-transition> -->
              <v-card-text
                class="d-flex justify-center align-center flex-column"
                style="height: 60vh"
              >
                <template v-if="!hasRequestedCRMIntegration">
                  <v-icon size="60" class="mb-4">mdi-puzzle</v-icon>
                  <!-- <div class="text-h6 font-weight-medium mb-3">
                
                </div> -->
                  <div class="mb-5 text-center">
                    Looking to use CRM Integration for your business? <br />
                    Hit the Send Request button and we will be in touch with you
                    shortly.
                  </div>

                  <v-btn
                    color="primary"
                    width="300"
                    depressed
                    large
                    @click="showSendRequestConfirmationDialog = true"
                    >Send Request</v-btn
                  >
                </template>
                <template v-else>
                  <v-icon size="60" class="mb-4" color="primary"
                    >mdi-check-circle</v-icon
                  >
                  <!-- <div class="text-h6 font-weight-medium mb-3">
                
                </div> -->
                  <div class="mb-5 text-center">
                    We have received your request about CRM Integration and will
                    be in touch with you shortly via email.
                  </div>

                  <v-btn
                    color="primary"
                    width="300"
                    depressed
                    large
                    outlined
                    @click="showRequestCancellationConfirmationDialog = true"
                    >Cancel Request</v-btn
                  >
                </template>
              </v-card-text>

              <SendRequestDialog
                requestType="CRM_INTEGRATION"
                :showDialog="sendRequestDialog"
                @canceled="sendRequestDialog = false"
              />

              <LoadingDialog
                :show="showLoadingDialog"
                title="Sending request..."
              />

              <ConfirmationDialog
                :show="showSendRequestConfirmationDialog"
                title="Send Request?"
                content="Pappyon would receive your request and would stay in touch."
                @click="sendRequest"
                @closeDialog="showSendRequestConfirmationDialog = false"
                buttonText="Send"
              />

              <ConfirmationDialog
                :show="showRequestCancellationConfirmationDialog"
                title="Cancel request?"
                content="Your request for CRM would be cancelled"
                @click="cancelRequest"
                @closeDialog="showRequestCancellationConfirmationDialog = false"
                buttonText="Cancel request"
              />
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SendRequestDialog from "@/components/SendRequestDialog";
import { mapActions, mapGetters } from "vuex";
import LoadingDialog from "@/components/LoadingDialog";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import {getHttpsCallable} from "@/shared/firebase_utils";

export default {
  name: "CRMIntegration",
  components: {
    SendRequestDialog,
    LoadingDialog,
    ConfirmationDialog,
  },
  data() {
    return {
      skeltonLoaderAttrs: {
        class: "my-2",
        boilerplate: true,
        elevation: 0,
        absolute: true,
        overlay: true,
      },
      overlay: false,
      sendRequestDialog: false,
      showLoadingDialog: false,
      showSendRequestConfirmationDialog: false,
      showRequestCancellationConfirmationDialog: false,
    };
  },
  computed: {
    ...mapGetters([
      "businessProfile",
      "loggedInUsersUid",
      "userProfile",
      "selectedBusinessProfileId",
    ]),
    hasRequestedCRMIntegration() {
      return this.businessProfile.hasRequestedCRMIntegration || false;
    },
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails"]),
    async sendRequest() {
      try {
        //Hide the confirmation dialog
        this.showSendRequestConfirmationDialog = false;

        //Show loading dialog
        this.showLoadingDialog = true;

        //Update business profile
        this.updateBusinessProfileDetails({
          hasRequestedCRMIntegration: true,
        });

        //Send email
        let emailData = {
          email: "connect@pappyon.com",
          businessName: this.businessProfile.businessName,
          loggedInUsersUid: this.loggedInUsersUid,
          firstName: this.userProfile.firstName,
          lastName: this.userProfile.lastName,
          userEmail: this.userProfile.email,
          selectedBusinessProfileId: this.selectedBusinessProfileId,
        };

        const sendEmail = getHttpsCallable("sendCRMIntegrationRequestEmail");
        const response = await sendEmail(emailData);

        //Hide loader
        this.showLoadingDialog = false;
      } catch (error) {
        console.log(
          "Error occurred while sending CRM request integration: ",
          error
        );
      }
    },
    cancelRequest() {
      //Hide the confirmation dialog
      this.showRequestCancellationConfirmationDialog = false;

      //Update business profile
      this.updateBusinessProfileDetails({
        hasRequestedCRMIntegration: false,
      });
    },
  },
};
</script>